// extracted by mini-css-extract-plugin
export var active = "Subnavigation-module--active--b2bab";
export var icon = "Subnavigation-module--icon--bc0e5";
export var link = "Subnavigation-module--link--509a8";
export var title = "Subnavigation-module--title--3bef1";
export var toc = "Subnavigation-module--toc--5e40e";
export var tocButton = "Subnavigation-module--toc-button--8c43e";
export var tocButtonGroup = "Subnavigation-module--toc-button-group--b94a4";
export var tocNav = "Subnavigation-module--toc-nav--35065";
export var tocNavOpen = "Subnavigation-module--toc-nav-open--74be6";